import {useState} from "react";
import {Box} from "@mui/material";
import MyStreamsList from "../components/MyStreamsList";

const MyStreamsPage = () => {
    const [refresh, setRefresh] = useState(false);
    const refreshStreams = () => setRefresh((prev) => !prev);

    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <MyStreamsList
                refreshTrigger={refresh}
                refreshStreams={refreshStreams}
            />
        </Box>
    );
};

export default MyStreamsPage;
